import React, { useEffect, useState } from "react";
import { Row, Form, Spinner } from "react-bootstrap";
import "./ReviewPage.css";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import reviews_org from "../../../assets/no_reviews.svg";
import { toast } from "react-toastify";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import { postRequestcall } from "../../comman/util/postRequest";
import { RATING, RATING_LIST } from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";
const  ReviewListPage  = React.lazy(() => import("../../comman/components/ReviewListPage"));
const  RattingCommanPage  = React.lazy(() => import("../../comman/components/RattingCommanPage"));

function ReviewPage(props) {
  const [ratinglist, setRatinglist] = useState([]);
  const { t } = useTranslation();
  let storeId = window.location.pathname.split("/").pop();
  const [loader, setLoader] = useState(false);
  const [writereview, setWitereview] = useState({
    review: "",
    rating: 0,
  });
  const [rating, setRating] = useState(0); // initial rating value
  const [errorMsg, setErrormsg] = useState({
    review: "",
    rating: "",
  });
  const navigate = useNavigate();

  // eslint-disable-next-line
  useEffect(() => {
    if (props.detailTab === "reviews") {
      (async () => getRatinglist())();
    }
    // eslint-disable-next-line
  }, [props.detailTab]);

  const getRatinglist = async () => {
    let geturl = RATING_LIST + `/${storeId}?page=${"1"}`;
    let getList = await getRequestcall(geturl, props?.access_token);
    if (getList?.status === 200) {
      let getResult = await getList.json();
      setRatinglist(getResult?.data?.data);
    }
  };

  // Catch Rating value
  const handleRating = (rate) => {
    setRating(rate);
    let rating;
    switch (rate * 20) {
      case 10:
        rating = 0.5;
        break;
      case 20:
        rating = 1;
        break;
      case 30:
        rating = 1.5;
        break;
      case 40:
        rating = 2;
        break;
      case 50:
        rating = 2.5;
        break;
      case 60:
        rating = 3;
        break;
      case 70:
        rating = 3.5;
        break;
      case 80:
        rating = 4;
        break;
      case 90:
        rating = 4.5;
        break;
      case 100:
        rating = 5;
        break;
      default:
        break;
    }
    setWitereview({
      ...writereview,
      rating: rating,
    });
    setErrormsg({
      ...errorMsg,
      rating: "",
    });
  };

  const reviewTextchange = (e) => {
    setWitereview({
      ...writereview,
      [e.target.name]: e.target.value,
    });

    setErrormsg({
      ...errorMsg,
      review: "",
    });
  };

  const validation = () => {
    let checkValue = true;

    if (writereview.review === "" || !writereview.review ) {
      errorMsg.review = "pages.storedetail.reviews.wrireUreview_warn";
      checkValue = false;
    }

    if (writereview.rating === 0) {
      errorMsg.rating = "pages.storedetail.reviews.ratting_warn";
      checkValue = false;
    }

    setErrormsg({
      review: errorMsg.review,
      rating: errorMsg.rating,
    });

    if (checkValue === true) {
      return true;
    } else {
      return false;
    }
  };

  const submitReview = async (e) => {
    e.preventDefault();
    setLoader(true);
    if (!props.access_token) {
      toast.error(t("pages.Please login"));
    } else {
      if (validation()) {
        let geturl =
          RATING +
          `?rating=${writereview.rating}&review=${writereview.review}&id=${storeId}`;
        let res = await postRequestcall(geturl, props?.access_token, "");
        if (res?.status === 200) {
          toast.success(t('pages.Review submitted successfully'));
          setWitereview({
            review: "",
            rating: 0,
          });
          setRating(0);
          getRatinglist();
        } else if (res.status === 401) {
          navigate("/", { state: { autologout: true } });
        }
      }
    }
    setLoader(false);
  };

  return (
    <div className="review-content review-common ">
      <Row>
        <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          {ratinglist?.length ? (
            ratinglist?.map((item, index) => (
              <ReviewListPage item={item}  key={index?.toString()} />
            ))
          ) : (
            <div id={"no_data_found"}>
              <LazyLoadImage src={reviews_org} alt={""}></LazyLoadImage>
              <h5>{t("pages.myreviews.noreview")}</h5>
              <p>{t("pages.myreviews.no_reviews")}</p>
            </div>
          )}
        </div>

        <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
          <div className="review-write">
            <h3>
              {props?.storedetail?.rating_ratio === ""
                ? ""
                : Number(props?.storedetail?.rating_ratio?.toFixed(1))}
            </h3>
            <div className="rating">
              <RattingCommanPage
                initialValue={props?.storedetail?.rating_ratio}
                readonly={true}
                size={20}
              />
              <h6>
                {ratinglist.length} {t("pages.storedetail.reviews.reviews")}
              </h6>
            </div>
            {props.storeDetail?.store_id !== storeId && (
              <button className="write-btn" hidden>
                {t("pages.storedetail.reviews.write_review")}
              </button>
            )}
          </div>
          {props.storeDetail?.store_id !== storeId && (
            <div className="feedback">
              <h5 className="give-text">
                {t("pages.storedetail.reviews.feedback")}
              </h5>
              <h6 className="rating-text">
                {t("pages.storedetail.reviews.ratting")}
              </h6>
              <RattingCommanPage
                onClick={handleRating}
                ratingValue={rating}
                readonly={false}
                size={25}
                allowHalfIcon
              />
              <div className="text-danger">{t(errorMsg.rating)}</div>
              <Form className="mt-3">
              <FormgroupPage as={"textarea"} style={{ height: "auto" }} rows={3} label={t("pages.storedetail.reviews.wrireUreview")} placeholder={t("pages.storedetail.reviews.wrireUreview_place")}
              value={writereview?.review} name={"review"} onChange={reviewTextchange} error={t(errorMsg.review)} />
                <div className="submit-rev">
                  <ButtonPage
                     className="button-secondry ml-auto"
                     onClick={(e) => loader ? e.preventDefault() : submitReview(e)}
                     Text={
                       <React.Fragment>
                         {loader ? (
                          <Spinner size={"sm"} animation="border" />
                        ) : (
                          t("pages.storedetail.reviews.submit")
                        )}
                       </React.Fragment>
                     }
                  />
                </div>
              </Form>
            </div>
          )}
        </div>
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  storeDetail: state?.dashboard?.storeDetail,
});

export default connect(mapStateToProps)(ReviewPage);
